import script from "./render-html.vue?vue&type=script&lang=js"
export * from "./render-html.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__